import { API_PREFIX } from "./api.constants";

export const ROLE_ENDPOINTS = {
  ROLES: `${API_PREFIX}/roles/`,
  ROLE_DETAIL: (roleId: number | string) => `${API_PREFIX}/roles/${roleId}`,
  ROLES_EXPORT: `${API_PREFIX}/roles/export`,
};